import { userConstants } from "../constants/login.constants";

  function ebinderCompanyList(state = {}, action) {
     switch (action.type) {
         case userConstants.EBINDERCOMPANYLIST_REQUEST:
             return {
                 loading: true
             };
         case userConstants.EBINDERCOMPANYLIST_SUCCESS:
             return {
                 items: action.ebinderCompanyList
             };
         case userConstants.EBINDERCOMPANYLIST_FAILURE:
             return {
                 error: action.error
             };
         default:
             return state
     }
 }
 export default ebinderCompanyList;